import { createMutation } from '@farfetched/core';
import { createEffect, createEvent, sample } from 'effector';

import { CreateOrderDto } from '@/shared/api/generated/api.generated';

export type OrderRequest = CreateOrderDto & { requestId: string; consent: true; consentVersion: string };

export const createOrderMutation = createMutation({
  effect: createEffect(async (request: OrderRequest) => {
    const response = await fetch('/api/v1/orders/request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
      signal: AbortSignal.timeout(20000),
    });
    const receipt = (await response.json().catch(() => null)) as { id?: string; accepted?: boolean } | null;
    if (!response.ok || !receipt?.accepted || !receipt.id)
      throw new Error(
        response.status === 429
          ? 'Слишком много запросов. Повторите через минуту.'
          : 'Не удалось отправить заявку. Корзина сохранена — повторите попытку или позвоните +7 (343) 363-05-07.',
      );
    return receipt;
  }),
});
